<div class="tab-content">
    <!-- ABOUT TAB -->
    <mat-tab-group>

        <!-- PROFILE CREATE -->
        <mat-tab label="Create profile" *ngIf="status=='create'">
            <div *ngIf="status=='create'" class="main-content-body tab-pane p-4 border-top-0 active">
                <!-- <div class="d-flex align-items-start pb-3 border-bottom"> <img src="{{getPhotoUrl()}}" class="img rounded-circle avatar-xl" alt="">
                    <div class="ps-sm-4 ps-2" id="img-section"> <b>Profile Photo</b>
                        <mat-form-field class="col-md-9" appearance="outline">
                            <mat-label>Image Url Token (cloudfare)</mat-label>
                            <input matInput type="text" placeholder="entre cloudfare token" [(ngModel)]="getClientDetails().imageUrl" name="imageUrl" required>
                            </mat-form-field>
                    </div>
                </div> -->
                <app-first-contact-form (dataOut)="createClientProfile($event)" [savedAnswersObj]="newClient" [mode]="'create'"></app-first-contact-form>
            </div>
        </mat-tab>

        <!-- ABOUT OR PREVIEW -->
        <mat-tab [label]="getLabel()">

            <div class="crm-dashboard">
                <!-- Header -->
                <div class="header" *ngIf="newClient">
                  <div class="profile-info">
                    <img
                      src="{{getImageUrl(newClient.imageUrl)}}"
                      alt="Client Profile"
                      class="profile-image"
                    />
                    <div>
                      <h2>{{getFieldValue('name')}} {{getFieldValue('lastname')}} {{getFieldValue('lastname2')}}</h2>
                      <p><i class="fas fa-calendar-alt"></i> Fecha de nacimiento: {{getFieldValue('birthday')}}</p>
                      <p><i class="fas fa-user"></i> Edad: {{getFieldValue('age')}}</p>
                      <p><i class="fas fa-briefcase"></i> Profesión: {{getFieldValue('career')}}</p>
                    </div>
                  </div>
                </div>
              
                <!-- Primary Info Section -->
                <div class="main-section">
                  <div class="card card-highlight">
                    <h3><i class="fas fa-bullseye"></i> Objetivo y Destino</h3>
                    <p><strong>Objetivo:</strong> {{getFieldValue('goal')}}</p>
                    <p><strong>Destino:</strong> {{getFieldValue('destination')}}</p>
                    <p><strong>Universidad:</strong> {{getFieldValue('university')}}</p>
                  </div>
                  <div class="card">
                    <h3><i class="fas fa-address-card"></i> Datos de Contacto</h3>
                    <p><i class="fas fa-envelope"></i> Email: {{getFieldValue('email')}}</p>
                    <p><i class="fas fa-phone"></i> Teléfono 1: {{getFieldValue('phone1')}}</p>
                    <p><i class="fas fa-phone"></i> Teléfono 2: {{getFieldValue('phone2')}}</p>
                    <p><i class="fas fa-globe"></i> País: {{getFieldValue('country')}}</p>
                  </div>
                </div>
              
                <!-- Details Section -->
                <div class="details-section">
                  <div class="card">
                    <h3><i class="fas fa-university"></i> Información Académica</h3>
                    <p><strong>Historial académico:</strong> {{getFieldValue('studyHistory')}}</p>
                    <p><strong>Estudios actuales:</strong> {{getFieldValue('currentStudies')}}</p>
                  </div>
                  <div class="card card-highlight">
                    <h3><i class="fas fa-plane"></i> Información de Viaje</h3>
                    <p><strong>Visa de estudiante:</strong> {{getFieldValue('hasStudentVisa')}}</p>
                    <p><strong>Visitas previas a Europa:</strong> {{getFieldValue('visitedCountries')}}</p>
                  </div>
                </div>
              
                <!-- Extras Section -->
                <div class="extras-section">
                  <div class="card">
                    <h3><i class="fas fa-clock"></i> Presente</h3>
                    <p>{{getFieldValue('present')}}</p>
                  </div>
                  <div class="card">
                    <h3><i class="fas fa-rocket"></i> Futuro</h3>
                    <p>{{getFieldValue('future')}}</p>
                  </div>
                  <div class="card">
                    <h3><i class="fas fa-comments"></i> Comentarios Adicionales</h3>
                    <p>{{getFieldValue('comments')}}</p>
                  </div>
                </div>
              </div>
              
              
        </mat-tab>

        <!-- PROFILE EDIT -->
        <mat-tab label="Edit profile" *ngIf="status=='update' || status=='edit'">
            <!-- <div class="d-flex align-items-start pb-3 border-bottom"> <img src="{{getPhotoUrl()}}" class="img rounded-circle avatar-xl" alt="">
                <div class="ps-sm-4 ps-2" id="img-section"> <b>Profile Photo</b>
                    <mat-form-field class="col-md-9" appearance="outline">
                        <mat-label>Image Url Token (cloudfare)</mat-label>
                        <input matInput type="text" placeholder="entre cloudfare token" [(ngModel)]="getClientDetails().imageUrl" name="imageUrl" required>
                        </mat-form-field>
                </div>
            </div> -->
            <mat-spinner *ngIf="loadingProfileInfo()"></mat-spinner>
            <app-first-contact-form *ngIf="!loadingProfileInfo()" (dataOut)="updateClientProfile($event)" [mode]="'update'" [savedAnswersObj]="newClient"></app-first-contact-form>
        
        </mat-tab>

        <!-- APPS ENABLED FOR CLIENT -->
        <mat-tab label="Apps" *ngIf="status=='update' || status=='edit'">
            <app-webapp-user-config [info]="getUserSelectedInfo()"></app-webapp-user-config>
        </mat-tab>

        <!-- PRODUCTS ACTIVATED -->
        <mat-tab label="Products" *ngIf="status=='update' || status=='edit'">
          <app-client-activated-tools [info]="getUserSelectedInfo()"></app-client-activated-tools>
      </mat-tab>

        <!-- BUDGET DETAIL -->
        <mat-tab label="Budget" *ngIf="status=='update' || status=='edit'">
          <app-pricing-plans  [packages]="getClientPackages()" *ngIf="getClientPackages().length>0"></app-pricing-plans><!-- *ngIf="!isLocked() && getClientPackages().length>0" -->
        </mat-tab>

        <!-- BUDGET DETAIL -->
        <mat-tab label="Process" *ngIf="status=='update' || status=='edit'">
          <app-client-process></app-client-process><!-- *ngIf="!isLocked() && getClientPackages().length>0" -->
        </mat-tab>
    
    </mat-tab-group>

</div>